import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=5b4d63bc&scoped=true&functional=true"
import script from "./Cell.vue?vue&type=script&lang=ts"
export * from "./Cell.vue?vue&type=script&lang=ts"
import style0 from "./Cell.vue?vue&type=style&index=0&id=5b4d63bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5b4d63bc",
  null
  
)

export default component.exports